export default "__VITE_ASSET__2fbee7b4__"